// DONT EDIT THIS FILE. AUTOGENERATED.
export enum SideBarTKeys {
    chatSupport = 'SideBar.chatSupport',
    developer = 'SideBar.developer',
    login = 'SideBar.login',
    settings = 'SideBar.settings',
    signup = 'SideBar.signup',
}
